export class GatePass {
    ref_no: number;
    company_id: number;
    gatepass_date: Date;
    gatepass_time: String;
    visitor_ref_no: number;
    otp_generated:String;
    otp_received:String;
    vehicle_no:String;
    no_of_packets_if_any:String;
    remarks_if_any:String;
    employee_permitted:String;
    employee_permitted_through:String;
    employee_message:String;
}
